import React, { createContext, useContext, useEffect, useState } from "react";

type OfficeContextType = {
  currentOffice: number | undefined;
  setCurrentOffice: React.Dispatch<React.SetStateAction<number | undefined>>;
};

const OfficeContext = createContext<OfficeContextType>({
  currentOffice: undefined,
  setCurrentOffice: () => undefined,
});

const useOfficeContext = (): OfficeContextType => {
  return useContext(OfficeContext);
};

const OfficeProvider = (props: { children: React.ReactNode }) => {
  const [currentOffice, setCurrentOffice] = useState<number | undefined>(undefined);
  let localStorage: Storage;

  if (typeof window !== "undefined") {
    localStorage = window.localStorage;
  }

  useEffect(() => {
    const currentOffice = localStorage.getItem("currentOffice");
    if (currentOffice) {
      setCurrentOffice(Number(currentOffice));
    }
  }, []);

  useEffect(() => {
    if (currentOffice) {
      localStorage.setItem("currentOffice", currentOffice.toString());
    }
  }, [currentOffice]);

  return (
    <OfficeContext.Provider value={{ currentOffice, setCurrentOffice }}>
      {props.children}
    </OfficeContext.Provider>
  );
};

export { useOfficeContext, OfficeProvider };
